<div class="premium-dialog-header">
  <div class="dialog-badge-icon dialog-badge-rose">
    <mat-icon>delete</mat-icon>
  </div>
  <h2>{{ 'deleteQuotation.title' | translate }}</h2>
</div>
<div mat-dialog-content>
  @if (error) {
    <div class="dialog-error">
      <p>{{ error | error }}</p>
    </div>
  }
  <p class="m-0">{{ 'deleteQuotation.text' | translate }} {{ quotation.erpId }}</p>
</div>
@if (progress) {
  <mat-progress-bar color="primary" mode="indeterminate"></mat-progress-bar>
}
<div mat-dialog-actions align="end">
  <button mat-stroked-button (click)="cancel()" class="action-button" [disabled]="progress">
    {{ 'ADMIN.CANCEL' | translate }}
  </button>
  <button mat-flat-button color="warn" (click)="delete()" class="action-button" [disabled]="progress">
    <mat-icon>delete</mat-icon>
    {{ 'COMMON.VALIDATE' | translate }}
  </button>
</div>
